import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { useDispatch as useAppDispatch, useSelector as useAppSelector, shallowEqual as useAppShallowEqual } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './slices/user';
import adminReducer from './slices/admin';
import companyReducer from './slices/company';
import storeReducer from './slices/store';
import employeeReducer from './slices/employee';
import employee_positionReducer from './slices/employee_position';
import employee_statusReducer from './slices/employee_status';
import stock_movementReducer from './slices/stock_movement';
import process_listReducer from './slices/process_list';
import marketplace_accountReducer from './slices/marketplace_account';
import marketplace_orderReducer from './slices/marketplace_order';
import marketplace_pull_orderReducer from './slices/marketplace_pull_order';
import marketplace_push_orderReducer from './slices/marketplace_push_order';
import productReducer from './slices/product';
import task_scheduleReducer from './slices/task_schedule';
import turboly_accountReducer from './slices/turboly_account';
import turboly_companyReducer from './slices/turboly_company';
import turboly_storeReducer from './slices/turboly_store';
import turboly_registerReducer from './slices/turboly_register';
import turboly_supplierReducer from './slices/turboly_supplier';
import turboly_salesReducer from './slices/turboly_sales';
import app_settingsReducer from './slices/app_settings';
import expenseReducer from './slices/expense';

// ----------------------------------------------------------------------
const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  // whitelist: ["user"],
  whitelist: [],
};

const rootReducer = combineReducers({
  user : userReducer,
  admin : adminReducer,
  company : companyReducer,
  store : storeReducer,
  employee : employeeReducer,
  employee_position : employee_positionReducer,
  employee_status : employee_statusReducer,
  stock_movement : stock_movementReducer,
  process_list : process_listReducer,
  marketplace_account : marketplace_accountReducer,
  marketplace_order : marketplace_orderReducer,
  marketplace_pull_order : marketplace_pull_orderReducer,
  marketplace_push_order : marketplace_push_orderReducer,
  product : productReducer,
  task_schedule : task_scheduleReducer,
  turboly_account : turboly_accountReducer,
  turboly_company : turboly_companyReducer,
  turboly_store : turboly_storeReducer,
  turboly_register : turboly_registerReducer,
  turboly_supplier : turboly_supplierReducer,
  turboly_sales : turboly_salesReducer,
  expense : expenseReducer,
  app_settings : app_settingsReducer,

});
const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

const persistor = persistStore(store);

const { dispatch } = store;
const useSelector = useAppSelector;
const shallowEqual = useAppShallowEqual;
const useDispatch = () => useAppDispatch();

export { store, persistor, dispatch, useSelector, shallowEqual, useDispatch };
// export { store, persistor, dispatch , useDispatch  };
